import type { User } from '@talos/kyoko';
import { useUserContext } from '@talos/kyoko';

export const useUser = (): User => {
  const { user } = useUserContext();
  return user;
};
